/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-03-24 16:12:13
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-04-11 14:56:38
 */
import { Color3, MeshBuilder, StandardMaterial, Vector3, } from '@babylonjs/core';
import MeshManage from '../meshManage';
import { AISLE_WIDTH, DOUBLE_DOOR_REFIRGERATOR_DISTANCE, FRAMECATEGORY, FRAMEDEPTH, HANDLEPOSITION, 
// SINGLE_DOOR_REFIRGERATOR_DISTANCE,
TOPFRAME_GROUND, TOP_SPECIAL_LEATHER_HANDLE_ID, } from '../utils/kitchenConfig';
class Refrigerator {
    constructor(templateJson, frame, length, type, scene) {
        this.cabinetFrameArr = []; // 冰箱顶柜数组
        this.cabinetMeshArr = []; // 冰箱顶柜meshManage数组
        this.distance = DOUBLE_DOOR_REFIRGERATOR_DISTANCE; // 冰箱两边应该有的间隔
        this.templateJson = templateJson;
        this.refrigeratorFrame = frame;
        this.length = length;
        this.type = type;
        this.scene = scene;
        this.refrigeratorMesh = new MeshManage(this.scene.getMeshByName(this.refrigeratorFrame.componentBasic.id));
        this.shadowMesh = null;
        if (['U', 'H'].includes(templateJson.bottom.type)) {
            this.shadowMesh = this.createRefrigeratorShadow();
        }
        if (this.hasCabinet()) {
            this.groupCabinetDoor();
        }
    }
    // 判断是否有冰箱柜 顶柜
    hasCabinet() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_c = (_b = (_a = this.refrigeratorFrame) === null || _a === void 0 ? void 0 : _a.fridgeArk) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length) && ((_f = (_e = (_d = this.refrigeratorFrame) === null || _d === void 0 ? void 0 : _d.fridgeArk) === null || _e === void 0 ? void 0 : _e.frames) === null || _f === void 0 ? void 0 : _f.length) !== 0) {
            this.cabinetFrameArr = (_h = (_g = this.refrigeratorFrame) === null || _g === void 0 ? void 0 : _g.fridgeArk) === null || _h === void 0 ? void 0 : _h.frames;
            return true;
        }
        return false;
    }
    /**
     * @description: 检查柜子是否是冰箱
     * @param {*} frame
     * @return {*}
     * @author: Zhanyu Shen
     */
    static checkFrameIsRefrigeraror(frame) {
        if (!frame) {
            return false;
        }
        if (frame.categoryId === FRAMECATEGORY.CATEGORY_39) {
            return true;
        }
        return false;
    }
    // 组合冰箱柜的顶柜跟柜门以及把手
    groupCabinetDoor() {
        var _a;
        this.cabinetFrameArr.forEach((item) => {
            this.cabinetMeshArr.push(new MeshManage(this.scene.getMeshByName(item.componentBasic.id)));
        });
        // 目前看单开门的冰箱跟顶柜是一样宽度没有间隙的 经沟通 单开门的冰箱当没有间隙处理
        if (((_a = this.refrigeratorFrame) === null || _a === void 0 ? void 0 : _a.width) === 60) {
            this.distance = this.cabinetMeshArr[0].getModelSize().x / 2 - this.refrigeratorMesh.getModelSize().x / 2;
        }
        this.groupCabinetAndDoors();
    }
    // 将冰箱柜跟冰箱组合成一个整体
    groupRefrigeratorAndCabinet() {
        this.cabinetMeshArr.forEach((item) => {
            this.refrigeratorMesh.addChildModel(item.mesh);
        });
    }
    // 初始化冰箱顶柜的位置
    initCabinetPosition() {
        if (this.cabinetMeshArr.length === 0)
            return;
        // 拿到顶柜最高的地方 然后摆放的Y是最高-柜体高度
        const homeHeight = TOPFRAME_GROUND(this.templateJson);
        // 如果只有一个就放在冰箱的正中间
        if (this.cabinetMeshArr.length === 1) {
            this.cabinetMeshArr[0].setModelPosition({
                x: 0,
                y: homeHeight - this.cabinetMeshArr[0].getModelSize().y,
                z: -this.refrigeratorMesh.getModelSize().z / 2 + this.cabinetMeshArr[0].getModelSize().z / 2,
            });
        }
        else {
            let leftIndex = 0; // 左边一个柜体的index
            let rightIndex = 1; // 右边一个柜体的index
            if (this.length !== 1) {
                leftIndex = 1;
                rightIndex = 0;
            }
            this.cabinetMeshArr[leftIndex].setModelPosition({
                x: this.refrigeratorMesh.getModelSize().x / 2 + this.distance
                    - this.cabinetMeshArr[leftIndex].getModelSize().x / 2,
                y: homeHeight - this.cabinetMeshArr[leftIndex].getModelSize().y,
                z: -this.refrigeratorMesh.getModelSize().z / 2 + this.cabinetMeshArr[leftIndex].getModelSize().z / 2,
            });
            this.cabinetMeshArr[rightIndex].setModelPosition({
                x: this.refrigeratorMesh.getModelSize().x / 2 + this.distance
                    - this.cabinetMeshArr[leftIndex].getModelSize().x - this.cabinetMeshArr[rightIndex].getModelSize().x / 2,
                y: homeHeight - this.cabinetMeshArr[rightIndex].getModelSize().y,
                z: -this.refrigeratorMesh.getModelSize().z / 2 + this.cabinetMeshArr[rightIndex].getModelSize().z / 2,
            });
        }
        this.groupRefrigeratorAndCabinet();
    }
    // 摆放冰箱柜的位置，冰箱组合的前面必定有一个侧板，根据这个侧板的位置来摆放冰箱
    setRefrigeratorPosition(sidePlateInfo) {
        let refrigeratorPosition = { x: 0, y: 0, z: 0 };
        let refrigeratorRotation = { x: 0, y: 0, z: 0 };
        switch (this.length) {
            case 1:
                refrigeratorPosition = this.lengthXPosition(sidePlateInfo.position);
                refrigeratorRotation = { x: 0, y: 0, z: 0 };
                break;
            case 2:
                refrigeratorPosition = this.lengthZPosition(sidePlateInfo.position);
                refrigeratorRotation = { x: 0, y: -Math.PI / 2, z: 0 };
                break;
            case 3:
                refrigeratorPosition = this.lengthP2XPosition(sidePlateInfo.position, sidePlateInfo.sideplateMesh);
                refrigeratorRotation = { x: 0, y: -Math.PI, z: 0 };
                break;
            default:
                break;
        }
        const { x, y, z } = refrigeratorRotation;
        this.refrigeratorMesh.addRotation(x, y, z);
        this.refrigeratorMesh.setModelPosition(refrigeratorPosition);
        if (this.shadowMesh) {
            this.shadowMesh.position = new Vector3(refrigeratorPosition.x, 0.005, refrigeratorPosition.z);
        }
    }
    // l1上面的冰箱位置摆放
    lengthXPosition(sidePlatePosition) {
        const refrigeratorPosition = {
            x: 0, y: 0, z: this.refrigeratorMesh.getModelSize().z / 2,
        };
        if (sidePlatePosition) {
            refrigeratorPosition.x = sidePlatePosition.x
                - this.refrigeratorMesh.getModelSize().x / 2 - this.distance;
        }
        else {
            // 如果不存在侧板的position那么说明冰箱单独在一边  这个时候冰箱占第一个柜体的位置 下面同理
            refrigeratorPosition.x = -this.refrigeratorMesh.getModelSize().x / 2 - this.distance;
        }
        return refrigeratorPosition;
    }
    // l2上面的冰箱位置摆放
    lengthZPosition(sidePlatePosition) {
        const refrigeratorPosition = {
            x: -this.refrigeratorMesh.getModelSize().z / 2, y: 0, z: 0,
        };
        if (sidePlatePosition) {
            refrigeratorPosition.z = sidePlatePosition.z
                + this.refrigeratorMesh.getModelSize().x / 2 + this.distance;
        }
        else {
            refrigeratorPosition.z = this.refrigeratorMesh.getModelSize().x / 2 + this.distance;
        }
        return refrigeratorPosition;
    }
    // l3上面的冰箱位置摆放
    lengthP2XPosition(sidePlatePosition, sideplateMesh) {
        const refrigeratorPosition = {
            x: 0, y: 0, z: 0,
        };
        const moveDistance = (sideplateMesh === null || sideplateMesh === void 0 ? void 0 : sideplateMesh.meshManage.getModelSize().x) / 2;
        if (sidePlatePosition) {
            refrigeratorPosition.x = sidePlatePosition.x
                - this.refrigeratorMesh.getModelSize().x / 2 - this.distance;
            refrigeratorPosition.z = sidePlatePosition.z + moveDistance
                - this.refrigeratorMesh.getModelSize().z / 2;
        }
        else {
            refrigeratorPosition.x = -this.refrigeratorMesh.getModelSize().x / 2 - this.distance;
            refrigeratorPosition.z = FRAMEDEPTH.BOTTOM + AISLE_WIDTH + this.refrigeratorMesh.getModelSize().z / 2;
        }
        return refrigeratorPosition;
    }
    // 创建阴影
    createRefrigeratorShadow() {
        const { x, z } = this.refrigeratorMesh.getModelSize();
        const shadowMesh = MeshBuilder.CreateGround('shadow', {
            width: x,
            height: z,
        }, this.scene);
        shadowMesh.position = new Vector3(0, 0, 0);
        const material = new StandardMaterial('texture', this.scene);
        material.diffuseColor = new Color3(0, 0, 0);
        material.alpha = 0.3;
        shadowMesh.material = material;
        return shadowMesh;
    }
    // 柜体安装门板  门板安装把手
    groupCabinetAndDoors() {
        if (this.cabinetFrameArr.length && this.cabinetFrameArr.length !== 0) {
            this.cabinetFrameArr.forEach((item, index) => {
                this.cabinetMeshArr[index] = new MeshManage(this.scene.getMeshByName(item.componentBasic.id));
                // 冰箱柜的柜门只有一个
                item.doors.forEach((doorItem) => {
                    const doorManage = new MeshManage(this.scene.getMeshByName(doorItem.componentBasic.id));
                    if (doorItem.handle) {
                        this.groupDoorsAndHandle(doorManage, doorItem);
                    }
                    doorManage.setModelPosition({
                        x: 0,
                        y: 0,
                        z: this.cabinetMeshArr[index].getModelSize().z / 2 + doorManage.getModelSize().z / 2,
                    });
                    this.cabinetMeshArr[index].addChildModel(doorManage);
                });
            });
            this.initCabinetPosition();
        }
    }
    // 门板安装把手
    groupDoorsAndHandle(doorManage, doorFrame) {
        var _a, _b;
        const handleInfo = doorFrame === null || doorFrame === void 0 ? void 0 : doorFrame.handle;
        const handleManage = new MeshManage(this.scene.getMeshByName((_a = handleInfo === null || handleInfo === void 0 ? void 0 : handleInfo.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        if (((_b = handleInfo === null || handleInfo === void 0 ? void 0 : handleInfo.componentBasic) === null || _b === void 0 ? void 0 : _b.componentId) === TOP_SPECIAL_LEATHER_HANDLE_ID) {
            handleManage.addRotation(Math.PI * 1.5, Math.PI / 2, -Math.PI / 2);
        }
        else {
            handleManage.addRotation(0, Math.PI / 2, -Math.PI / 2);
        }
        // 把手特例调整   如果宽度大于柜子就竖着装   小于柜子的话不变
        if (handleManage.getModelSize().z > doorManage.getModelSize().x) {
            handleManage.addRotation(0, Math.PI / 2, 0);
        }
        handleManage.setModelPosition({
            x: doorManage.getModelSize().x / 2 - HANDLEPOSITION.FRAMETOPTOLEFT - handleManage.getModelSize().x / 2,
            y: HANDLEPOSITION.FRAMETOPTOBOTTOM,
            z: doorManage.getModelSize().z,
        });
        doorManage.addChildModel(handleManage.mesh);
    }
}
export default Refrigerator;
